<template>
	<no-ssr>
		<span>
			<!-- Google Tag Manager (noscript) -->
			<noscript><iframe :src="`https://www.googletagmanager.com/ns.html?id=${$store.state.config.googleTagManagerKey}`"
			height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
			<!-- End Google Tag Manager (noscript) -->
			<script type="application/javascript">
				(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
						new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
					j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
					'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
				})(window,document,'script','dataLayer','{{$store.state.config.googleTagManagerKey}}');
			</script>
			<script async :src="`https://www.googletagmanager.com/gtag/js?id=${$store.state.config.gtagKey}`"></script>
			<script>
				window.dataLayer = window.dataLayer || [];
				function gtag(){dataLayer.push(arguments);}
				gtag('js', new Date());
				gtag('config', '{{$store.state.config.gtagKey}}');
			</script>
		</span>
	</no-ssr>
</template>

<script>
export default {
}
</script>
